import { render } from "./SidebarFooter.vue?vue&type=template&id=4c89f0c7&scoped=true&ts=true"
import script from "./SidebarFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarFooter.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarFooter.vue?vue&type=style&index=0&id=4c89f0c7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c89f0c7"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/SidebarFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c89f0c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c89f0c7', __exports__)) {
    api.reload('4c89f0c7', __exports__)
  }
  
  module.hot.accept("./SidebarFooter.vue?vue&type=template&id=4c89f0c7&scoped=true&ts=true", () => {
    api.rerender('4c89f0c7', render)
  })

}


export default __exports__